<template>
	<section>
		<table class="table table-sm table-bordered" v-loading="loadings.items">
			<tbody>
				<tr v-for="(model,model_id) in modelHash" :key="model_id">
					<th>{{model.name}}</th>
					<td>
						<div class v-if="stocks[itemsMatrix[model.index]]">
							<el-input
								v-model.number="stocks[itemsMatrix[model.index]].amount"
								size="mini"
								style="width:10em"
								@input="handleFormEdited"
								:disabled="isCheckLessThanHolder && stocks[itemsMatrix[model.index]].oldAmount<=0 && stocks[itemsMatrix[model.index]].inPreSale<=0"
							></el-input>
							<span class="text-muted text-smaller">原有:{{stocks[itemsMatrix[model.index]].oldAmount}}</span>
							<span
								class="text-muted text-smaller"
								v-if="stocks[itemsMatrix[model.index]].inSell"
							>/ 在售:{{stocks[itemsMatrix[model.index]].inSell}}</span>
							<span
								class="text-muted text-smaller"
								v-if="stocks[itemsMatrix[model.index]].inPreSale"
							>/ 预售:{{stocks[itemsMatrix[model.index]].inPreSale}}</span>
						</div>
					</td>
				</tr>
			</tbody>
		</table>
		<div class="p-3" @click="hasExpand=!hasExpand">展开编辑</div>
		<div class="p-3" v-show="hasExpand">
			<el-button
				class="mb-3"
				plain
				size="mini"
				icon="el-icon-circle-plus-outline"
				@click="handleItemsAddNew('models')"
			>尺码/型号</el-button>
			<el-tooltip
				:content="calcPresetDetail(preset.models)"
				placement="top"
				v-for="(preset,index) in totalModelPreset"
				:key="preset._id"
			>
				<el-button
					type="primary"
					size="mini"
					class="mb-3"
					@click="handleItemsAddNewModelPreset(index)"
				>+ {{preset.name}}</el-button>
			</el-tooltip>

			<el-button
				plain
				size="mini"
				class="mb-3"
				icon="el-icon-circle-plus-outline"
				@click="gotoProductEdit(product_color._id)"
			>信息编辑</el-button>
		</div>
		<el-dialog :title="'选择颜色'" :visible.sync="colors.dialog">
			<div v-if="colors.dialog">
				<color-input v-model="colors.color" :filter-brand="product_color.brand"></color-input>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="colors.dialog = false">取 消</el-button>
				<el-button type="primary" @click="doChoose('colors')">确 定</el-button>
			</span>
		</el-dialog>
		<el-dialog title="选择款式" :visible.sync="models.dialog">
			<div v-if="models.dialog">
				<model-input v-model="models.model" :filter-classify="product_color.classify"></model-input>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="models.dialog = false">取 消</el-button>
				<el-button type="primary" @click="doChoose('models')">确 定</el-button>
			</span>
		</el-dialog>
	</section>
</template>

<script>
import ColorInput from "@/widgets/Inputs/ColorInput.vue";
import ModelInput from "@/widgets/Inputs/ModelInput.vue";
export default {
	data() {
		return {
			loadings: {
				items: false,
			},
			everEdited: false,
			items: [],
			stocks: [],
			colors: {
				dialog: false,
				color: {
					_id: "",
					name: "",
					brand_show_id: "",
				},
			},
			models: {
				dialog: false,
				model: {
					_id: "",
					name: "",
				},
			},
			totalModelPreset: [],
			hasExpand: false,
		};
	},
	props: {
		product_color: {
			type: Object,
			default: () => {
				return {
					name: "",
					_id: "",
					filter: [
						{
							name: "brand",
							value: "",
						},
					],
					colors: [],
					models: [],
					brand: {
						name: "",
						_id: "",
					},
					classify: [],
				};
			},
		},
		warehouseId: {
			type: String,
			default: "",
		},
		isCheckLessThanHolder: {
			type: Boolean,
			default: false,
		},
		isDiffMode: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		colorHash() {
			let obj = {};
			if (!this.product_color.colors) {
				return obj;
			}
			for (let i = 0; i < this.product_color.colors.length; i++) {
				obj[this.product_color.colors[i]._id] = {
					index: i,
					name: this.product_color.colors[i].name,
				};
			}
			return obj;
		},
		modelHash() {
			let obj = {};
			if (!this.product_color.models) {
				return obj;
			}
			for (let i = 0; i < this.product_color.models.length; i++) {
				obj[this.product_color.models[i]._id] = {
					index: i,
					_id: this.product_color.models[i]._id,
					name: this.product_color.models[i].name,
				};
			}

			return obj;
		},
		itemsMatrix() {
			let items = [];
			for (let i = 0; i < this.product_color.models.length; i++) {
				items.push(-1);
			}
			for (let k = 0; k < this.items.length; k++) {
				let model = this.items[k].model._id;
				if (!this.modelHash[model]) {
					continue;
				}
				items[this.modelHash[model].index] = k;
			}
			return items;
		},
	},
	mounted() {},
	methods: {
		calcPresetDetail(presetModels) {
			return presetModels
				.map(val => {
					return val.name;
				})
				.join(",");
		},
		getTotalModelPreset() {
			this.$axios
				.post("/inventory/get_model_preset/", {
					classify: this.product_color.classify,
				})
				.then(json => {
					this.totalModelPreset = json.data.datas;
				})
				.catch(json => {
					console.error(json);
					this.$message.error(json.data.msg);
				});
		},
		gotoProductEdit(id) {
			let routeData = this.$router.resolve({
				name: "Config-SPU-Edit",
				params: {
					id: id,
				},
			});

			window.open(routeData.href, "_blank");
		},
		handleItemsAddNewModelPreset(index) {
			this.$confirm(
				"确认使用" +
					this.totalModelPreset[index].name +
					"预置尺码：" +
					this.calcPresetDetail(this.totalModelPreset[index].models),
				"提示",
				{
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				},
			)
				.then(() => {
					this.loadings.main = true;
					this.$axios
						.post(`/inventory/add_preset_model/${this.product_color._id}`, {
							preset: this.totalModelPreset[index]._id,
						})
						.then(json => {
							this.loadings.main = false;

							for (let k in json.data.info) {
								this.$set(this.product_color, k, json.data.info[k]);
							}
							this.refreshItemData();
							this.$emit("itemchange");
						})
						.catch(json => {
							this.loadings.main = false;
							this.$message.error(json.data.msg);
						});
				})
				.catch(() => {
					this.$message({
						type: "info",
						message: "已取消",
					});
				});
		},
		handleResetClear() {
			if (!this.isDiffMode) {
				this.stocks = this.stocks.map(val => {
					val.amount = 0;
					return val;
				});
			}

			this.handleFormEdited();
		},
		handleFormEdited() {
			this.everEdited = true;

			if (this.isCheckLessThanHolder) {
				let _flag = 0;
				for (let i = 0; i < this.stocks.length; i++) {
					if (
						this.stocks[i].amount > this.stocks[i].oldAmount &&
						this.stocks[i].oldAmount > 0
					) {
						this.stocks[i].amount = this.stocks[i].oldAmount;

						_flag = 1;
						break;
					}
				}
				if (_flag == 1) {
					this.$message.error("不可输入比原始数量更高的数量");
				}
			}
			let stocks;
			if (this.isDiffMode) {
				stocks = this.stocks
					.filter(val => {
						return val.amount - val.oldAmount != 0;
					})
					.map(val => {
						let thatVal = Object.assign({}, val);
						thatVal.amount = val.amount - val.oldAmount;
						return thatVal;
					});
			} else {
				stocks = this.stocks.filter(val => {
					return val.amount > 0;
				});
			}

			this.$emit("change", stocks);
			this.$emit("input", stocks);
		},
		handleItemsAddNew(type) {
			this[type].dialog = true;
			this.reset(type);
		},
		reset(type) {
			this[type].index = -1;
		},
		doChoose(type) {
			if (this[type].index == -1) {
				//创建

				this.loadings.items = true;
				this.$axios
					.post(`/inventory/add_items/${type}/${this.product_color._id}`, {
						model: this.models.model,
					})
					.then(json => {
						this.loadings.items = false;
						this[type].dialog = false;
						for (let k in json.data.info) {
							this.$set(this.product_color, k, json.data.info[k]);
						}
						this.refreshItemData();
						this.$emit("itemchange");
					})
					.catch(json => {
						this.loadings.items = false;
						this.$message.error(json.data.msg);
					});
			} else {
				this.loadings.items = true;
				let post = {
					old_id: this.product_color[type][this[type].index]._id,
				};
				post["model"] = this.models.model;

				this.$axios
					.post(`/inventory/replace_items/${type}/${this.product_color._id}`, post)
					.then(json => {
						this.loadings.items = false;
						this[type].dialog = false;
						for (let k in json.data.info) {
							this.$set(this.product_color, k, json.data.info[k]);
						}
						this.refreshItemData();
						this.$emit("itemchange");
					})
					.catch(json => {
						this.loadings.items = false;
						this.$message.error(json.data.msg);
					});
			}
		},
		refreshItemData() {
			this.loadings.items = true;
			//和仓库无关，直接拿数量
			this.$axios
				.post(`/inventory/list_items/${this.product_color._id}`)
				.then(json => {
					this.loadings.items = false;
					this.items = [];

					for (let k in json.data.datas) {
						this.items.push(json.data.datas[k]);
					}
					if (this.warehouseId != "") {
						//如果设置了仓库，则只取一个仓库的数量
						this.mapStocksInWarehouse();
					} else {
						this.mapStocksByItem();
					}
				})
				.catch(json => {
					this.loadings.items = false;
				});
		},
		//@deprecated
		refreshStockData() {
			// this.loadings.items = true;
			// //如果设置了仓库，则只取一个仓库的数量
			// this.$axios
			// 	.post(`/inventory/list_stocks/${this.product_color._id}`, {
			// 		warehouse: this.warehouseId
			// 	})
			// 	.then(json => {
			// 		this.loadings.items = false;
			// 		this.mapStocksInWarehouse(json.data.stocks);
			// 	})
			// 	.catch(json => {
			// 		this.loadings.items = false;
			// 	});
		},
		mapStocksByItem() {
			let stockItemMapping = {};
			this.items.forEach(val => {
				stockItemMapping[val._id] = val.amount;
			});
			// debugger;
			let stocks = [];
			for (let i = 0; i < this.items.length; i++) {
				let amount = 0;
				let oldAmount = 0;

				if (stockItemMapping[this.items[i]._id]) {
					oldAmount = stockItemMapping[this.items[i]._id];
					if (this.isDiffMode) {
						amount = stockItemMapping[this.items[i]._id];
					}
				}
				stocks.push({
					amount: amount,
					oldAmount: oldAmount,
					inSell: this.items[i].amount_temporary,
					inPreSale: this.items[i].amount_pre,
					_id: this.items[i]._id,
					info: this.items[i],
				});
			}
			this.stocks = stocks;
		},
		mapStocksInWarehouse() {
			// let stockItemMapping = {};
			// stocksData.forEach(val => {
			// 	stockItemMapping[val.item._id] = val.amount;
			// });
			let stocks = [];
			for (let i = 0; i < this.items.length; i++) {
				let amount = 0;
				let oldAmount = 0;
				let inSell = this.items[i].amount_temporary;

				if (
					this.items[i].amount_warehouse &&
					this.items[i].amount_warehouse[this.warehouseId]
				) {
					oldAmount = this.items[i].amount_warehouse[this.warehouseId];
					if (this.isDiffMode) {
						amount = oldAmount;
					}
				}
				stocks.push({
					amount: amount,
					oldAmount: oldAmount,
					inSell: inSell,
					inPreSale: this.items[i].amount_pre,
					_id: this.items[i]._id,
					info: this.items[i],
				});
			}
			this.stocks = stocks;
		},
	},

	components: {
		ColorInput,
		ModelInput,
	},
	watch: {
		"product_color._id": {
			handler(val) {
				if (this.product_color._id != "") {
					this.refreshItemData();
					this.getTotalModelPreset();
				} else {
					this.items = [];
				}
			},
			immediate: true,
		},
		warehouseId() {
			this.mapStocksInWarehouse();
		},
	},
};
</script>
<style lang="scss" scoped>
</style>
